function NullableValue({ children }) {
  return children === undefined || children === null ? "-" : children;
}

export default NullableValue;
